var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCardThree({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 58,
    viewBox: "0 0 53 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3332 41.188V46.4261C33.3332 48.3206 32.5806 50.1374 31.2411 51.4769C29.9015 52.8165 28.0847 53.5691 26.1903 53.5691C24.2959 53.5691 22.479 52.8165 21.1395 51.4769C19.7999 50.1374 19.0474 48.3206 19.0474 46.4261V41.188",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1907 53.5715V55.9525",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.5719 42.6834V28.569C28.5719 27.8627 28.7813 27.1721 29.1738 26.5848C29.5662 25.9975 30.124 25.5397 30.7766 25.2694C31.4292 24.9991 32.1473 24.9284 32.8401 25.0662C33.5329 25.204 34.1692 25.5441 34.6687 26.0436C35.1682 26.5431 35.5084 27.1795 35.6462 27.8723C35.784 28.5651 35.7132 29.2832 35.4429 29.9358C35.1726 30.5884 34.7148 31.1461 34.1275 31.5386C33.5402 31.931 32.8497 32.1405 32.1433 32.1405H20.2385C19.5321 32.1405 18.8416 31.931 18.2543 31.5386C17.6669 31.1461 17.2092 30.5884 16.9389 29.9358C16.6685 29.2832 16.5978 28.5651 16.7356 27.8723C16.8734 27.1795 17.2136 26.5431 17.7131 26.0436C18.2125 25.5441 18.8489 25.204 19.5417 25.0662C20.2345 24.9284 20.9526 24.9991 21.6052 25.2694C22.2578 25.5397 22.8156 25.9975 23.208 26.5848C23.6005 27.1721 23.8099 27.8627 23.8099 28.569V42.681",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.145 47.6191H33.2356",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1905 42.8571C35.3953 42.8571 42.8573 35.3951 42.8573 26.1903C42.8573 16.9854 35.3953 9.52344 26.1905 9.52344C16.9857 9.52344 9.52368 16.9854 9.52368 26.1903C9.52368 35.3951 16.9857 42.8571 26.1905 42.8571Z",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1907 1.19043V3.5714",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 8.51465L10.196 10.198",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19043 26.1904H3.5714",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 43.8699L10.196 42.1865",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8684 43.8699L42.1851 42.1865",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1903 26.1904H48.8093",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8684 8.51465L42.1851 10.198",
    stroke: "#6263AB",
    strokeWidth: 2.38097,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardThree);
export default __webpack_public_path__ + "static/media/icon-card-three.890579d77c7429693a52b5f6ec10040f.svg";
export { ForwardRef as ReactComponent };